export class FieldControlTypeDto {
    controlTypeId: number;
    controlTypeName: string;

    constructor(init: any) {
        this.controlTypeId = init.ControlTypeID;
        this.controlTypeName = init.ControlTypeName;
    }
}
